import { motion, useReducedMotion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const benefits = [
  "A clear picture of exactly how many more clients your firm could be bringing in",
  "A look at what a full pipeline system would look like for your firm",
  "A realistic view of what your client volume could look like in 90 days",
  "Completely on your terms — if it's the right fit, we'll both know",
];

export function FinalCTA() {
  const reduced = useReducedMotion();
  const navigate = useNavigate();

  return (
    <section id="free-audit" className="py-8 md:py-12 relative overflow-hidden">
      <div className="max-w-3xl mx-auto px-4 text-center relative z-10">
        <motion.h2
          initial={reduced ? {} : { opacity: 0, y: 20 }}
          whileInView={reduced ? {} : { opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground leading-tight tracking-tight"
        >
          Find out exactly how many more clients your firm could be bringing in.
        </motion.h2>
        <p className="mt-3 text-xl text-muted-foreground">
          Book a free Pipeline Audit — straight to value, straight to results.
        </p>
        <p className="mt-3 text-muted-foreground leading-relaxed">
          In 30 minutes, we'll look at your current intake process and show you the exact opportunities to bring in more clients. You'll walk away with a clear action plan — whether you work with us or on your own.
        </p>

        <ul className="mt-5 space-y-2 text-left max-w-md mx-auto">
          {benefits.map((b) => (
            <li key={b} className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" />
              <span className="text-foreground text-sm">{b}</span>
            </li>
          ))}
        </ul>

        <motion.button
          whileHover={reduced ? {} : { scale: 1.05 }}
          whileTap={reduced ? {} : { scale: 0.97 }}
          className="mt-6 bg-primary text-primary-foreground font-semibold text-lg px-10 py-5 rounded-full shadow-lg hover:shadow-xl transition-shadow"
          onClick={() => navigate("/audit")}
        >
          Claim Your Free Pipeline Audit
        </motion.button>

        <p className="mt-3 text-xs text-muted-foreground">
          Spots are limited. We only take on a small number of new firms each month.
        </p>
      </div>
    </section>
  );
}
